import { render, staticRenderFns } from "./CompForm.vue?vue&type=template&id=4040d3fe&"
import script from "./CompForm.vue?vue&type=script&lang=js&"
export * from "./CompForm.vue?vue&type=script&lang=js&"
import style0 from "./CompForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports